import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const taglines = [
  "Roost easy — your next match is just a peck away.",
  "We don’t take 40%. We take your side (and maybe a nap).",
  "Wake up. Match up. No fluff, no fuss, just freedom.",
  "Your wake-up call just matched with your dream role.",
  "Cock-a-doodle-direct — staffing without the middlemen.",
  "Early bird gets the contract. Agencies hit snooze.",
  "The rooster’s crowing. Time to ghost your agency.",
  "Tired of clucking around? Try RxRooster.",
  "Built by CRNAs. Backed by facilities. Feathered with pride.",
  "Match faster. Crow louder. Work freer."
];

const TaglineCarousel = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % taglines.length);
    }, 7000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="tagline-carousel text-white fw-bold">
      <AnimatePresence mode="wait">
        <motion.div
          key={taglines[index]}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <h1 className="display-5">{taglines[index]}</h1>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default TaglineCarousel;
